import { render, staticRenderFns } from "./Presencial.vue?vue&type=template&id=6dd3208c&scoped=true"
import script from "./Presencial.vue?vue&type=script&lang=js"
export * from "./Presencial.vue?vue&type=script&lang=js"
import style0 from "./Presencial.vue?vue&type=style&index=0&id=6dd3208c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3208c",
  null
  
)

export default component.exports